
(function() {

    var untickAll = function($templateCache) {
        return {
            restrict: "E",
            replace: true,
            transclude: true,
            template: $templateCache.get('components/listing/untickAll.html'),
            bindToController: { // isolated scope
                ticked: "="
            },
            controllerAs: 'ctrl',
            controller: function($scope) {

                var _this = this;

                /**
                 * Function that clears all items ticked
                 */
                $scope.clearTicked = function (){
                    angular.forEach(_this.ticked, function(val, key) {
                        if (val == true){
                            _this.ticked[key] = false;
                        }else{
                            angular.forEach(_this.ticked[key], function(val, tickKey) {
                                _this.ticked[key][tickKey] = false;
                            });
                        }
                    });
                }
            }
        };
    }
    untickAll.$inject = ['$templateCache'];
    angular.module('app').directive('untickAll', untickAll);

}());